import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

export default () => ({
    el_dialog: null,
    onClickOpenDialog( event ) {
        this.$refs.dialog.showModal();

    },
    onClickClose( event ) {
        // console.log( "CLOSE" );
        this.$refs.dialog.close();

    },

    init() {
        // console.log( 'Modal', { 'this': this, '$refs': this.$refs, 'dialog': this.$refs['dialog'] } );
        let self = this;

        self.$refs.dialog.addEventListener( 'click', ( event ) => {
            // console.log( 'outside proxy', { event, 'is proxy?': event.target === self.$refs.dialog } );
            if ( event.target === self.$refs.dialog ) {
                self.$refs.dialog.close();
            }
        } );

    }
});
